export default __webpack_public_path__ + "static/media/36I-120629_-43880_0.76061f3f.jpg";